<template>
  <div class='modalWrapper'>
    <div class='overlay' @click='hideModal()'></div>
    <div class='modal checkout'>
      <i class='close fa fa-times' @click='hideModal()'></i>
      <h1>Checkout</h1>
      <div>We accept: <i class='fa fa-cc-paypal' aria-hidden='true'></i></div><br>
      <h3> Subtotal: {{ cartSubTotal | currency }} </h3>
      <h3> Shipping: {{ shippingTotal | currency }} </h3>
      <h3 v-if="cartCuponPrice > 0" class="discount"> Discount: - {{ cartCuponPrice | currency }} </h3>
      <h3 v-show="tax"> Tax: {{ tax | currency }} </h3>
      <h1> Total: {{ grandTotal | currency }} </h1>
      <br>

      <div>
        <div class='align_item'><label><strong>Recipient name: <span  v-bind:class="{ red: !recipient.name }">*</span> </strong></label><input v-model="recipient.name"></div>
        <div class='align_item'><label><strong>Recipient phone: <span  v-bind:class="{ red: !recipient.phone }">*</span> </strong></label><input :placeholder="dialCode" v-model="recipient.phone"></div>
        <div class='align_item'><label><strong>Address: <span  v-bind:class="{ red: !recipient.address }">*</span> </strong></label><input v-model="recipient.address" @change="validateAddress"></div>
        <div class='align_item'><label><strong>Country: <span  v-bind:class="{ red: !recipient.countryCode }">*</span> </strong></label>
          <select v-model="recipient.countryCode">
            <option value="">--select country--</option>
            <option v-for="(country, idx) in countries"  :value="country.code" :key="idx">
              {{ country.name }}
            </option>
          </select>
        </div>
        <div class='align_item'><label><strong>State: {{stateRequired(recipient.countryCode) ? '*' : ''}} </strong></label>
          <select v-if="recipient.countryCode == 'US'" v-model="recipient.state">
            <option value="">--select state--</option>
            <option v-for="(usState, idx) in usStates" :value="usState.abbreviation" :key="idx">
              {{ usState.name }}
            </option>
          </select>
          <input v-else v-model="recipient.otherState">
        </div>
        <div class='align_item'><label><strong>City: <span  v-bind:class="{ red: !recipient.city }">*</span> </strong></label><input v-model="recipient.city"></div>
        <div class='align_item'><label><strong>Postal Code: <span  v-bind:class="{ red: !recipient.postalCode }">*</span> </strong></label><input type="number" v-model="recipient.postalCode"></div>
        
        <div class='align_item'><label><strong>Add Promo Code: </strong></label>
          <div class="group-input">
            <input v-model="recipient.promo"  class="input-group" >
            <input type="button" value="Apply Promo" class="button-group" v-on:click="checkPromo()" > 
            <span class="promo-msg" v-show="matchPromoMsg">
             Congratulations you have received a store credit worth {{cartCuponPrice | currency}}
            </span>
            <span class="promo-msg-err" v-show="unMatchPromoMsg">
              Promo "{{recipient.promo}}" does not exist!
            </span>
          </div>                       
        </div>
        <div class="loader-div">
          <div class="loader" v-show="enableLoader"></div>
        </div> 
        <div class="form-group">
          <input type="checkbox" v-model="recipient.terms" id="html">
          <label for="html"> <strong>Return Policy: <span  v-bind:class="{ red: !recipient.terms }">*</span>  </strong> No Returns or Exchange on Skincare & Makeup products.</label>
        </div>



        <p class='align_item warn-msg' v-show="showRequireMsg">N.B. Fields with asterisk(*) are required.</p>

        <br>

        <div class='align_item' id='paypal-button-container'></div>
      </div>
      
      <div id='paypal-button-container'></div>
    </div>
  </div>
</template>

<script>
  import common from '../common';
  import {bus} from '../main';
  import dropdownList from '@/assets/js/dropdownList';
  import axios from 'axios';
  var {api} = common;
  let {countries, usStates} = dropdownList;
  let {paypalExtra} = common;

  let recipientSkel = {
    name: '',
    phone: '',
    address: '',
    city: '', // 'San Jose',
    state: '', // 'CA',
    otherState: '',
    countryCode: 'US',
    postalCode: '', // '95131',
  };


  export default {
    name: "CheckoutDetail",
    props: ['cart', 'cartSubTotal', 'shippingTotal', 'cartTotal',],
    data: function() {
      return {
        recipient: {...recipientSkel},
        countries: countries,
        usStates: usStates,
        ppValidateActions: null,
        showRequireMsg: true,
        matchPromoMsg: false,
        unMatchPromoMsg: false,
        cartCuponPrice: 0,
        enableLoader: false,
      }
    },
    computed: {
      tax: function(){
        return this.recipient.countryCode == 'US' && this.recipient.state == 'NY' ? parseFloat((this.cartSubTotal * 0.08875).toFixed(2)) : 0;
      },
      grandTotal: function(){
        var total =  (this.cartSubTotal + this.shippingTotal + this.tax) - this.cartCuponPrice;
        return total.toFixed(2);
      },
      dialCode: function(){
        let country = countries.filter(c => c.code == this.recipient.countryCode);
        return country && country.length ? country[0].dial_code : '';
      }
    },
    filters: {
      currency: function(price){
        return '$' + price;
      },
    },
    methods: {
      checkPromo: function() {
        this.cartCuponPrice = 0;
        this.enableLoader = true;
        axios.get(api + 'admin/allpromo').then((resp) => {
          for (var i = 0; i < resp.data.length;  i++) {
            if(resp.data[i].code === this.recipient.promo){
              this.matchPromoMsg = true;
              this.unMatchPromoMsg = false;
              //if(localStorage.getItem('promoCode') == resp.data)
              if(resp.data[i].type == 1){
                //localStorage.setItem('promoCode', resp.data[i].code)
                this.cartCuponPrice = ((resp.data[i].price / 100) * this.grandTotal).toFixed(2); 
              }else if(resp.data[i].type == 2){
                this.cartCuponPrice = (resp.data[i].price).toFixed(2); 
              }
              this.enableLoader = false;
              return false;
              
            }
          }
          this.unMatchPromoMsg = true;
          this.matchPromoMsg = false;
          this.enableLoader = false;
        });
      },
      hideModal: function() {
        bus.$emit('checkoutModalHide');
      },
      stateRequired: function(country){
        if(country=='AR'||country=='BR'||country=='CA'||country=='CN'||country=='IN'||country=='IT'||country=='JP'||country=='MX'||country=='TH'||country=='US') return true;
        else return false;
      },
      validateAddress: function(){
        var re = new RegExp(".*po.*box");
        if(re.test(this.recipient.address.toLowerCase())) {
          alert('PO Box not allowed!');
          this.recipient.address = '';
        }
      }
    },

    watch: {
      recipient: {
        handler: function() {
          let stateValidated = (this.stateRequired(this.recipient.countryCode) && this.recipient.state) ? true : (!this.stateRequired(this.recipient.countryCode) && this.recipient.otherState) ? true : false;
          if (this.ppValidateActions &&
            this.recipient.name &&
            this.recipient.phone &&
            this.recipient.address &&
            this.recipient.countryCode &&
            stateValidated &&
            this.recipient.city &&
            this.recipient.postalCode &&
            this.recipient.terms
          ) {
            this.ppValidateActions.enable();
            this.showRequireMsg = false;
          } else {
            this.ppValidateActions.disable();
            this.showRequireMsg = true;
          }
        },
        deep: true
      }
    },

    mounted() {
      init_paypal.call(this);
    }
}

let init_paypal = function() {
  let that = this;
  paypal.Button.render({
    env: paypalExtra.mode, // sandbox | production

    // PayPal Client IDs - replace with your own
    // Create a PayPal app: https://developer.paypal.com/developer/applications/create
    client: {
      sandbox: paypalExtra.sandbox_id,
      production: paypalExtra.production_id
    },

    // Show the buyer a 'Pay Now' button in the checkout flow
    commit: true,

    // payment() is called when the button is clicked

    validate: (actions) => {
      actions.disable();
      this.ppValidateActions = actions;
    },

    onClick: () => {
      console.log();
    },

    payment: (data, actions) => {
      var payment_details = {
        total: this.grandTotal,
        subtotal: this.cartSubTotal + this.shippingTotal,
        currency: 'USD',
        recipientName: this.recipient.name,
        phone: this.recipient.phone,
        tax: this.tax,
        shipping: '0.00',
      };

      return actions.payment.create({
        transactions: [{
          amount: {
            total: payment_details.total,
            currency:  payment_details.currency,
            details: {
              subtotal: payment_details.subtotal,
              tax: payment_details.tax,
              shipping: payment_details.shipping,
              handling_fee: '0.00',
              shipping_discount: this.cartCuponPrice,
              insurance: '0.00'
            }
          },
          description: 'The payment transaction description.',
          custom: '90048630024435',
          //invoice_number: '12345', Insert a unique invoice number
          payment_options: {
            allowed_payment_method: 'INSTANT_FUNDING_SOURCE'
          },
          soft_descriptor: 'ECHI5786786',
          item_list: {
            items: this.cart.map(function(item){
              return {
                name: item.title,
                description: item.description,
                quantity: item.quantity,
                price: parseInt(item.price) + parseInt(item.shipping_charge),
                currency: payment_details.currency
              }
            }),
            shipping_address: {
              recipient_name: this.recipient.name,
              line1: this.recipient.address,
              line2: '',
              city: this.recipient.city,
              country_code: this.recipient.countryCode,
              postal_code: this.recipient.postalCode,
              phone: this.recipient.phone,
              state: this.recipient.countryCode == 'US' ? this.recipient.state : this.recipient.otherState,
            }
          }
        }],
        note_to_payer: 'Contact us for any questions on your order.'
      });
    },

    // onAuthorize() is called when the buyer approves the payment
    onAuthorize: (data, actions) => {

      // Make a call to the REST api to execute the payment
      return actions.payment.execute().then(function() {
        window.alert('Payment Complete!');
        that.recipient = {...recipientSkel};
        bus.$emit('resetCart');
      });
    },
    onCancel: function (data, actions) {
      alert('Payment cancelled!')
    },
    onError: function (err) {
      alert('Failed to validate payment!');

    }
  }, '#paypal-button-container');
}




</script>

<style scope>
  select {
    display: inline-block;
    padding: 0.5em;
    margin: 0.5em 0.5em 0.5em 0;
    transition: all 0.1s;
    font-size: 14px;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    width: 50%;
  }

  input {
    width: 50%;
  }

  .group-input{
    width: 50%;
    left: -6px;
    position: relative;
    margin-top:6px;
  }

  .group-input .input-group{
    width: 60%;
    margin: 0px;
  }
  .group-input .button-group{
    width: 40%;
    margin: 0px;
  }
  .promo-msg-err{
    color:red;
    text-align: left;
    display: block;
    font-size: 12px;
    line-height: 24px;
  }
  .promo-msg{
    color:green;
    text-align: left;
    display: block;
    font-size: 12px;
    line-height: 24px;
  }
  span.red{
    color:red;
  }
  .discount{
    color:green;
  }



/*css loder */
.loader {
  position: relative;
  top: -49px;
  left: 272px;

  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #333;
  width: 50px;
  height: 50px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-div{
  height:0px;
}
</style>